import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Button from '../../../components/Button/Button';
import './index.css';

export default function ModalError(props) {
  const { isOpen, onClose, isLongFileName } = props;
  return (
    <Modal style={customStyles} ariaHideApp={false} isOpen={isOpen}>
      <div className={'no-benefit-modal'} />
      <div id="full_description">
        <div
          className="justify-content-between"
          style={{
            textAlign: 'left',
            fontSize: 18,
          }}
        >
          {isLongFileName && <p>The name of the document you are trying to upload is too long.</p>}
          {isLongFileName && <p>Please ensure the file name is 50 characters or less and try again.</p>}
          {!isLongFileName && <p>File with same name already exists.</p>}
          {!isLongFileName && <p>If you are uploading another file with same name</p>}
          {!isLongFileName && <p>then please change the name and upload.</p>}
        </div>
      </div>
      <div className="row justify-content-center mt-10">
        <div className="col-auto">
          <Button
            backgroundColor="#44b4a6 "
            hoverBackgroundColor="#3e9e92"
            padding="13px 25px"
            borderRadius="8px"
            borderColor="transparent"
            fontSize="1em"
            onClick={onClose}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
}

ModalError.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isLongFileName: PropTypes.bool,
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#ffedee',
    color: '#ff0000',
    width: '80%,',
    textAlign: 'left',
    borderRadius: 5,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#b4b4b4',
    minWidth: 400,
    overflow: 'visible',
    maxWidth: 800,
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,.75)',
  },
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/components/ModalError/index.js